<template>
  <div class="changeInternalRemarks cus-modal">
    <Form :model="formData" :label-width="90">
      <!-- 修改内部备注 -->
      <FormItem :label="`${t('修改内部备注')}:`">
        <Input
          v-model="formData.remark"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4 }"
          :placeholder="t('请输入')"
        ></Input>
      </FormItem>
    </Form>
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>

export default {
  data() {
    return {
      formData: {
        remark: '', // 修改内部备注
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            type: '', // 按钮类型
            text: t('取消'),
            icon: '', // 按钮图标
            size: 'small', // 按钮大小
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            text: t('确定'),
            type: 'primary',
            size: 'small', // 按钮大小
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.determine();
            }, // 按钮点击事件
          }
        ],
      },
      spinShow: false,
    }
  },
  props: {
    componentData: {
      type: Object,
    }
  },
  methods: {
    determine() {
      let data;
      if (typeof this.componentData.ids === 'string') {
        data = this.componentData.ids;
      } else {
        data = typeof this.componentData.ids === 'number' ? this.componentData.ids : this.componentData.ids.join(',');
      }
      this.$Modal.info({
        title: t('提示'), // 提示
        className: 'ark-dialog',
        content: t('是否确定修改内部备注？'), // 是否确定修改内部备注？
        mask: true,
        showCancel: true,
        onOk: () => {
          const fromdata = new FormData();
          const param = {
            ids: data,
            insideRemark: this.formData.remark,
            order_flag: 1,
            cover: false,
          };
          fromdata.append('param', JSON.stringify(param));
          this.spinShow = true;
          this.service.orderCenter.bacthUpdateInsideRemark(param).then(res => {
            this.spinShow = false;
            this.$parent.$parent.closeConfirm();
            if (res.data.code === 0) {
              // $fcSuccess({
              //   content: res.data.message
              // })
              this.$Message.success(res.data.message);
              // this.$parent.$parent.$parent.load();
              this.$parent.$parent.$parent.getData();
              this.$parent.$parent.$parent.selection = [];
            } else {
              $fcError(res.data.message)
            }
          })
        },
      })
    },
  }
}
</script>

<style lang="less" scoped>
</style>
